import React from 'react'

import { ReactComponent as WarningIcon } from '@app/assets/Small/Filled/Warning.svg'
import { useIntl } from '@app/intl/Intl'
import { bemJoin, classNames } from '@app/lib/bem'

import './ReportProblem.scss'

const b = bemJoin('report-problem')

type ReportProblemNavBarEntryProps = {
  onClick: () => void
}

export const ReportProblemNavBarEntry = ({ onClick }: ReportProblemNavBarEntryProps) => {
  const { formatMessage } = useIntl()

  return (
    <button
      type='button'
      className={classNames('mecl-navBar__entry', 'mecl-navBar__entry--withoutBubble', b('entry'))}
      onClick={onClick}
    >
      <div className={classNames('mecl-navBar__entryIconWrapper', b('icon'))}>
        <WarningIcon />
      </div>
      <div className='mecl-navBar__entryTitle'>
        {formatMessage({ id: 'ReportProblem.Button.Open' })}
      </div>
    </button>
  )
}
